module.exports = __webpack_public_path__ + "img/Weapon_277.aa2e0120.png";